import React, {useContext, useState} from 'react';
import __ from "../../../i18n";
import Button from "../../../../bootstrap/components/button/Button";
import Request from "../../../../bootstrap/api/Request";
import LibraryEnrollParcel from "../../../api/endpoints/library/LibraryEnrollParcel";
import Toasts, {TOAST_ERROR, TOAST_SUCCESS} from "../../../../bootstrap/scomponents/toasts/Toasts";
import routes from "../../../routing/routes";
import {useHistory} from "react-router-dom";
import AuthContext from "../../../contexts/auth/AuthContext";
import HistoryContext from "../../../contexts/history/HistoryContext";


export default function FreeEnrollButton({course}) {

    const {user} = useContext(AuthContext);

    const historyContext = useContext(HistoryContext);

    const history = useHistory();

    const [isRequesting, setIsRequesting] = useState(false);

    const redirectLogin = () => {
        historyContext.setLoginReferer(history.location);
        history.push(routes.login.getUrl());
    };

    const requestFreeEnrollment = () => {
        if (isRequesting) {
            return;
        }

        setIsRequesting(true);

        Request.add(new LibraryEnrollParcel(course.id))
            .then(data => {
                setIsRequesting(false);
                Toasts.add(TOAST_SUCCESS, __('You have successfully enrolled in the course'));
                history.push(routes.learning.getUrl(course.id, 0));
            })
            .catch(error => {
                setIsRequesting(false);
                Toasts.add(TOAST_ERROR, error.getMessage());
            });
    };

    const handleClick = () => {
        if (user === null) {
            redirectLogin();
            return;
        }

        requestFreeEnrollment();
    };

    return <Button
        title={isRequesting ? __('Processing...') : __('Enroll now')}
        appearance={isRequesting ? 'text-primary' : 'solid-primary'}
        size="large"
        viewOnly={isRequesting}
        onClick={() => handleClick()}
    />;
}
